import React, { useState, useEffect } from "react";
import { EMPTY, SHOW_FIELD } from "../../configurations/Constants";
import { useSelector, useDispatch } from "react-redux";
import { formType } from "../../configurations/redux-configurations/actions/fieldAction";
import { Popover, Button, Form, Row, Col, CloseButton } from "react-bootstrap";
import { ADDED_FIELDS_WARNING } from "../../configurations/MessageConstants";

function Claim(props) {
  const dispatch = useDispatch();
  const DisplayForm = useSelector((state) => state.field.form_display);
  const [display_form, setDisplay_form] = useState(EMPTY);

  useEffect(() => {
    setDisplay_form(DisplayForm);
  }, [DisplayForm]);

  const confirmAction = (event) => {
    event.preventDefault();
    dispatch(formType(SHOW_FIELD));
  };

  return (
    <div>
      <div
        id="warning"
        className={display_form === "show_warning" ? EMPTY : "hide-form"}
      >
        <Popover.Header>Warning</Popover.Header>
        <CloseButton
          className="close"
          variant="white"
          onClick={(event) => props.hideWarningPopup(event)}
        />
        <Popover.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md="12">
                <Form.Label className="warningLabel">
                  <br />
                  {ADDED_FIELDS_WARNING}
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md="12" className="mt-12">
                <Button
                  className="mt-2"
                  onClick={(e) => props.hideWarningPopup(e)}
                >
                  OK{" "}
                </Button>
              </Form.Group>
            </Row>
          </Form>
        </Popover.Body>
      </div>
      <div
        id="confirm"
        className={display_form === "show_confirm" ? EMPTY : "hide-form"}
      >
        <Popover.Header>Claim Field</Popover.Header>
        <CloseButton
          className="close"
          variant="white"
          onClick={(event) => props.hideWarningPopup(event)}
        />
        <Popover.Body>
          <Form>
            <Row>
              <Form.Group as={Col} md="12">
                <Form.Label>
                  This field is already registered by another farmer.
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label>
                  Is this your field, do you want to claim it?
                </Form.Label>
              </Form.Group>
              <Form.Group as={Col} md="12" className="mt-12">
                <Button className="mt-2" onClick={(e) => confirmAction(e)}>
                  Yes
                </Button>{" "}
                <Button
                  className="mt-2"
                  onClick={(e) => props.hideWarningPopup(e)}
                >
                  No{" "}
                </Button>
              </Form.Group>
            </Row>
          </Form>
        </Popover.Body>
      </div>
    </div>
  );
}

export default Claim;
